import { Typography } from '@mui/material'
import { formatNumber } from '../../utils/Utils'

const TrackingKeywordShareOfVoice = ({ data }) => {

  if (!data) {
    return
  }

  let shareOfVoice = 0;
  if (data.history && data.history.length > 0) {
    shareOfVoice = data.history.reverse()[0].shareOfVoice
  }

  return (
    <Typography>{formatNumber(shareOfVoice, 2)}%</Typography>
  )

}

export default TrackingKeywordShareOfVoice;